"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadSchemaProperties = exports.ThreadSchema = void 0;
const zod_1 = require("zod");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.ThreadSchema = zod_1.z.object({
    id: zod_1.z.string(),
    count: zod_1.z.number(),
    subject: zod_1.z.string(),
    status: zod_1.z.string(),
    date: zod_1.z.date(),
});
exports.ThreadSchemaProperties = {
    collectionName: "threads",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=thread-schema.js.map